(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var SEL = 'main[data-template^="collection"] .card-gallery[data-image-ratio="square"]';

    function setup() {
      document.querySelectorAll(SEL).forEach(function (gallery) {
        if (gallery.dataset.jhCard) return;
        gallery.dataset.jhCard = '1';

        var slides = gallery.querySelectorAll('slideshow-slide');
        if (slides.length < 2) return;

        var dots = document.createElement('div');
        dots.className = 'jh-card-dots';
        dots.setAttribute('aria-hidden', 'true');
        slides.forEach(function () { dots.appendChild(document.createElement('span')); });
        gallery.after(dots);

        var sync = function () {
          slides.forEach(function (slide, i) {
            dots.children[i].classList.toggle('is-active', slide.getAttribute('aria-hidden') !== 'true');
          });
        };
        sync();
        var observer = new MutationObserver(sync);
        slides.forEach(function (slide) {
          observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
        });
      });
    }

    function start() {
      var main = document.querySelector('main[data-template^="collection"]');
      if (!main) return;
      setup();
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(setup, 100);
      }).observe(main, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
